import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { SurveyAnswer, SurveyQuestion } from "../../../types";
import { RootState } from "../../../../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { TranslateDescription } from "../../../../../../types/TranslateDescription";
import { addAnswer, removeAnswer } from "../../../../../../redux/surveySlice";
import { QuestionOptionsOrientationEnum } from "../../../types/enum";

interface SurveyQuestionAnswerProps {
    index: number;
    updateQuestionField: (index: number, field: keyof SurveyQuestion, value: any) => void;
    updateAnswerField: (questionIndex: number, answerIndex: number, field: keyof SurveyAnswer, value: any) => void;
    updateAnswerMultilangueField: (questionIndex: number, answerIndex: number, language: keyof TranslateDescription, field: keyof SurveyAnswer, value: any) => void; //TODO: Utilizar cuando se añada multilenguaje
    updateAnswerAllMultilanguesField: (questionIndex: number, answerIndex: number, field: keyof SurveyAnswer, value: any) => void;
}

export default function SurveyQuestionAnswerOption({ index, updateQuestionField, updateAnswerField, updateAnswerAllMultilanguesField }: SurveyQuestionAnswerProps) {
    const { t } = useTranslation(['surveyAdmin', 'common']);
    const dispatch = useDispatch();

    const errors = useSelector((state: RootState) => state.surveyForm.errors);
    const question = useSelector((state: RootState) => state.surveyForm.data.questions[index]);

    return (
        <>
            <Row>
                <Col md={9}>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("surveyAdmin:dafaultValue")}</Form.Label>
                                <Form.Select
                                    as="select"
                                    value={question.optionDefaultValueText ?? ""}
                                    onChange={(e) => { updateQuestionField(index, 'optionDefaultValueText', e.target.value) }}
                                >
                                    <option value=""></option>
                                    {question.answerOptions.map((value, index) =>
                                        (<option key={index} value={value.text.catalan}>
                                            {value.text.catalan} 
                                        </option>)
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("surveyAdmin:responseOrientation")}</Form.Label>
                                <Form.Select
                                    as="select"
                                    value={question.orientation ?? ""}
                                    onChange={(e) => { updateQuestionField(index, 'orientation', e.target.value) }}
                                >
                                    {Object.values(QuestionOptionsOrientationEnum).filter((key) => isNaN(Number(key))).map((name, index) => {
                                        const value = QuestionOptionsOrientationEnum[name as keyof typeof QuestionOptionsOrientationEnum];
                                        return (<option key={index} value={value}>
                                            {name} 
                                        </option>)
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Label></Form.Label>
                            <Form.Check
                                type="switch"
                                label={t("surveyAdmin:selectMoreThanOneOption")}
                                checked={question.isMultiselector}
                                onChange={(e) => { updateQuestionField(index, 'isMultiselector', e.target.checked) }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {question.answerOptions.map((option, answerIndex) => (
                <Row key={answerIndex}>
                    <Col md={5}>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t("surveyAdmin:textOption")} ${answerIndex+1}`} *</Form.Label>
                            <Form.Control
                                value={option.text.catalan ?? ''}
                                onChange={(e) => {
                                    updateAnswerAllMultilanguesField(index, answerIndex, 'text', e.target.value);
                                }}
                                isInvalid={!!errors[`questions[${index}].answerOptions[${answerIndex}].text.catalan`]}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors[`questions[${index}].answerOptions[${answerIndex}].text.catalan`]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:value")}</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                value={option.value ?? 0}
                                onChange={(e) => updateAnswerField(index, answerIndex, 'value', e.target.value)}
                            />
                        </Form.Group>                                    
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:puntuation")}</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                value={option.puntuation ?? 0}
                                onChange={(e) => updateAnswerField(index, answerIndex, 'puntuation', e.target.value)}
                            />
                        </Form.Group>                                    
                    </Col>
                    <Col md={1} className="d-flex justify-content-center align-items-center">
                        <Button
                            onClick={() => dispatch(removeAnswer({
                                questionIndex: index,
                                answerIndex: answerIndex
                            }))}
                            className="btn btn-sm btn-gris2 mt-4"
                        >
                            <i className="bi bi-x"></i>
                        </Button>
                    </Col>
                </Row>
            ))}
            <Row>
                <Col md={12}>
                    <Button
                        className="float-end"
                        variant="primary"
                        onClick={() => {
                            dispatch(addAnswer({questionIndex: index}));
                        }}
                    >
                        {t("surveyAdmin:addAnswer")}
                    </Button>
                </Col>
            </Row>
        </>
    );
}